class PredictiveSearch extends HTMLElement {
    constructor() {
        super();

        this.input = this.querySelector('input[type="search"]');
        this.predictiveSearchResults = this.querySelector("#predictive-search");
        this.header = this.closest(".mm-header");
        
        // Sécurisation des éléments header
        if (this.header) {
            this.headerBottom = this.header.querySelector(".mm-header-bottom");
            this.headerIcons = this.header.querySelector(".mm-header-icons");
        }

        this.handleFocus = this.handleFocus.bind(this);
        this.outsideClickHandler = this.outsideClickHandler.bind(this);

        this.input.addEventListener("focus", this.handleFocus);
        document.addEventListener('click', this.outsideClickHandler);

        this.predictiveSearchResults.addEventListener('click', (event) => {
            const target = event.target.closest('a, button');

            if (!target) return;

            if (target.tagName === 'A') {
                this.close();
            } else if (target.tagName === 'BUTTON') {
                const form = this.input.closest('form');
                if (form) {
                    // IMPORTANT: requestSubmit permet de déclencher l'écouteur 'submit' personnalisé plus bas
                    if (typeof form.requestSubmit === 'function') {
                        form.requestSubmit();
                    } else {
                        form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
                    }
                }
            }
        });

        this.input.addEventListener(
            "input",
            this.debounce((event) => {
                this.onChange(event);
            }, 300).bind(this)
        );
    }

    handleFocus() {
        this.open();
        this.getSearchResults("_");
        if (this.headerBottom) {
            this.headerBottom.style.display = "none";
        }
    }

    outsideClickHandler(event) {
        if (this.predictiveSearchResults.style.display === 'block' && !this.contains(event.target)) {
            this.close();
        }
    }

    onChange() {
        const searchTerm = this.input.value
            .trim()
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");

        this.getSearchResults(searchTerm);
    }

    getSearchResults(searchTerm = "_") {
        fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
            .then((response) => {
                if (!response.ok) {
                    var error = new Error(response.status);
                    this.close();
                    throw error;
                }
                return response.text();
            })
            .then((text) => {
                const resultsMarkup = new DOMParser().parseFromString(text, "text/html").querySelector("#shopify-section-predictive-search").innerHTML;
                this.predictiveSearchResults.innerHTML = resultsMarkup;
                this.open();
                
                // Gestion affichage mobile si vide
                if (searchTerm === "_" || searchTerm.length === 0) {
                    this.predictiveSearchResults.classList.add('no-products-mobile');
                } else {
                    this.predictiveSearchResults.classList.remove('no-products-mobile');
                }
            })
            .catch((error) => {
                this.close();
                throw error;
            });
    }

    open() {
        this.input.removeEventListener("focus", this.handleFocus);
        this.predictiveSearchResults.style.display = "block";
        if (typeof showBgFilter === 'function') showBgFilter();
    }

    close() {
        this.predictiveSearchResults.style.display = "none";
        if (typeof hideBgFilter === 'function') hideBgFilter();

        if (this.headerBottom) {
            this.headerBottom.style.display = "block";
        }

        setTimeout(() => {
            this.input.addEventListener("focus", this.handleFocus);
        }, 500);
    }

    debounce(fn, wait) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
        };
    }
}

customElements.define("predictive-search", PredictiveSearch);

// ---------------------------------------------------------
// LOGIQUE DE REDIRECTION PERSONNALISÉE
// ---------------------------------------------------------
function setUpSearchForm() {
    // Cibler tous les formulaires de recherche (Desktop & Mobile)
    const searchForms = document.querySelectorAll('predictive-search form');
    if (searchForms.length === 0) return;

    const handleSubmit = (event) => {
        const currentForm = event.target;
        const searchInput = currentForm.querySelector('input[type="search"]');
        
        if (!searchInput) return;

        // Nettoyage du terme recherché
        const searchTerm = searchInput.value
            .trim()
            .toLowerCase()
            .normalize("NFD")
            .replace("'", " ")
            .replace("’", " ")
            .replace(/[\u0300-\u036f]/g, ""); // Enlève les accents

        // Récupérer les inputs générés par Liquid (Table nm_table_search)
        const correspondenceInputs = document.querySelectorAll('.nm_table_search');

        for (const input of correspondenceInputs) {
            try {
                let rawTermes = input.dataset.termes;
                let termesArray = [];

                if (rawTermes) {
                    // 1. On essaie de lire comme du JSON (format ["a", "b"])
                    try {
                        const parsed = JSON.parse(rawTermes);
                        if (Array.isArray(parsed)) {
                            termesArray = parsed;
                        } else {
                            // Si c'est une simple chaine JSONifiée
                            // On regarde si elle contient des virgules pour découper
                            const str = parsed.toString();
                            if (str.includes(',')) {
                                termesArray = str.split(',').map(t => t.trim());
                            } else {
                                termesArray = [str];
                            }
                        }
                    } catch (e) {
                        // 2. Si ce n'est pas du JSON, on découpe par virgule directement
                        if (rawTermes.includes(',')) {
                            termesArray = rawTermes.split(',').map(t => t.trim());
                        } else {
                            termesArray = [rawTermes];
                        }
                    }
                }


                // Vérification de correspondance
                const isMatch = termesArray.some(terme => 
                    searchTerm === terme
                        .toLowerCase()
                        .normalize("NFD")
                        .replace(/['’]/g, " ") // <--- AJOUT : On nettoie aussi les apostrophes ici
                        .replace(/[\u0300-\u036f]/g, "")
                        .trim()
                );

                if (isMatch) {
                    event.preventDefault(); // Annule la recherche Shopify
                    event.stopPropagation();

                    // Récupération des infos de redirection
                    const productCount = parseInt(input.dataset.count || '0', 10);
                    const parentUrl = input.dataset.parent;
                    const directUrl = input.value;

                    console.log(`🔎 Match: "${searchTerm}"`);
                    console.log(`📦 Collection: ${directUrl} (Produits: ${productCount})`);
                    console.log(`⬆️ Parent: ${parentUrl}`);

                    // --- LOGIQUE METIER ---
                    // Si 0 produit et qu'un parent existe => Redirection Parent
                    if (productCount === 0 && parentUrl && parentUrl.trim() !== "") {
                        console.log("👉 Redirection vers parent (Stock épuisé)");
                        window.location.href = parentUrl;
                    } else {
                        // Sinon => Redirection normale vers la collection
                        console.log("👉 Redirection vers collection");
                        window.location.href = directUrl;
                    }
                    return; // Stop tout traitement
                }
            } catch (error) {
                console.error('Erreur dans la redirection search:', error);
            }
        }
    };

    // Attacher l'écouteur à chaque formulaire
    searchForms.forEach(form => {
        // On retire d'abord pour éviter les doublons lors des rechargements AJAX
        form.removeEventListener('submit', handleSubmit);
        form.addEventListener('submit', handleSubmit);
    });
}

// Initialisation au chargement et à la navigation
document.addEventListener('DOMContentLoaded', setUpSearchForm);
window.addEventListener('pageshow', setUpSearchForm);
document.addEventListener('shopify:section:load', setUpSearchForm);